export const FORM_FIELDS = {
  DONATOR_NAME: 'donator_name',
  DONATOR_EMAIL: 'donator_email',
  DONATOR_PHONE: 'donator_phone',
  OFFERING_CONTENT: 'offering_content',
  OFFERING_AMOUNT: 'offering_amount',
  FORM_AGREEMENT: 'mass_offerings_form_agreement',
  PAYMENT_TYPE: 'payment_type',
  USER_COVERS_SERVICE_FEE: 'user_covers_service_fee',
  TOTAL_AMOUNT_TO_PAY: 'total_amount_to_pay',
};

export const MASS_OFFERINGS_PAYMENT_TYPES = {
  online: 'online',
  toBeChosen: 'to_be_chosen',
};
